import React from 'react';
import { Box, Grid, Typography } from "@mui/material";
import QuickNavigation from "../components/common/quick-navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { useTenant } from "../contexts/tenant-context";

const Admin = () => {
  const { isGlobalAdmin, selectedTenantId, selectedTenant } = useTenant();
  const isActingAsGlobalAdmin = isGlobalAdmin && selectedTenantId === '__GLOBAL_ADMIN__';
  const isTenantAdmin = selectedTenant?.role?.toLowerCase() === "admin";

  return (
    <Box sx={{ width: "100%", mt: 3 }}>
      <Typography
        variant="h6"
        align="center"
        fontWeight={700}
        color="#fff"
        sx={{ mb: 3 }}
      >
        Quick Navigation
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <QuickNavigation
            icon={<FontAwesomeIcon icon={faUsers} />}
            actions={[{ label: "Manage Users", route: "/userAccess" }]}
            title="User Access"
            description="Manage user accounts, roles, and permissions"
          />
        </Grid>
        {!isActingAsGlobalAdmin && isTenantAdmin && (
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <QuickNavigation
              icon={<FontAwesomeIcon icon={faUsers} />}
              actions={[{ label: "Tenant Management", route: "/access-management/tenant-management" }]}
              title="Tenant Management"
              description="Manage tenant details, offwing reasons, operators, and display preferences"
            />
          </Grid>
        )}
        {isActingAsGlobalAdmin && (
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <QuickNavigation
              icon={<FontAwesomeIcon icon={faUsers} />}
              actions={[{ label: "Manage Tenants", route: "/on-board/tenant-management" }]}
              title="Tenant Access"
              description="Manage Tenants accounts and feature"
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Admin;